import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { plannedUnitId, isSlimeUnit, residueStacks, slimeSetDependencies, tableOf, } from './slime-helpers.js';
const planning = planningTargets([
    targetStep('receiver', unitTarget({
        side: 'ally',
        cardinality: { min: 1, max: 1 },
        where: ({ unit }) => unit.traits.includes('SLIME'),
    })),
]);
export const PullIntoClotCard = defineGameCard({
    id: 'pull_into_clot',
    gameplay: { type: 'SPELL', cost: 2, planning },
    presentation: {
        name: 'Стянуться в ком',
        description: 'Выбранный ваш слизень в этом раунде наносит совокупный урон всех слизней в его локации. Остальные слизни в этой локации не атакуют.',
        glyph: {
            colors: ['#10213A', '#96C653', '#3A624D', '#74AD4C', '#5E984F'],
            rows: [
                '....................',
                '.......1111.........',
                '......122221........',
                '......1212121111....',
                '..111122222232431...',
                '.15444422224414131..',
                '.15141424444344441..',
                '.154442444444441221.',
                '.1354244444444122221',
                '.1355441444141212141',
                '..115441444141222221',
                '...15444444441224221',
                '...14444444444143441',
                '...1555555555311111.',
                '..1555555553331.....',
                '.155555333333331....',
                '13333333333333331...',
                '.111111111111111....',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('pull_into_clot'), ...slimeSetDependencies()],
    abilities: [onResolve((ctx) => {
            const receiverId = plannedUnitId(ctx, 'receiver');
            const controllerId = ctx.self?.controllerId;
            const receiver = receiverId === undefined ? null : ctx.q.instance(receiverId);
            if (controllerId === undefined || receiver?.cellId === undefined
                || receiver.controllerId !== controllerId || !isSlimeUnit(receiver))
                return;
            const receiverTableId = tableOf(receiver.cellId);
            const slimes = ctx.q.allUnits().filter((unit) => unit.cellId !== undefined
                && tableOf(unit.cellId) === receiverTableId
                && isSlimeUnit(unit));
            const otherAttack = slimes
                .filter((unit) => unit.id !== receiver.id)
                .reduce((total, unit) => total + ctx.q.stats(unit.id).attack
                + (unit.cellId === undefined ? 0 : residueStacks(ctx, unit.cellId)), 0);
            if (otherAttack > 0) {
                ctx.ops.addEffect({
                    defId: PullIntoClotCard.id,
                    scope: { kind: 'unit', instanceId: receiver.id },
                    sourceId: ctx.self.id,
                    duration: 1,
                    persistent: true,
                    statMods: [{ stat: 'attack', op: 'add', value: otherAttack }],
                });
            }
            for (const slime of slimes) {
                if (slime.id === receiver.id)
                    continue;
                ctx.ops.addEffect({
                    defId: PullIntoClotCard.id,
                    scope: { kind: 'unit', instanceId: slime.id },
                    sourceId: ctx.self.id,
                    duration: 1,
                    persistent: true,
                    vars: { attackPermission: 'prohibit' },
                });
            }
        })],
    ui: {
        mechanics: ['cannot_attack'],
        planning: {
            steps: {
                receiver: { label: 'Выберите атакующего слизня' },
            },
        },
        effectStatusProviders: [(_context, effects) => {
                const effect = effects[0];
                if (effect === undefined)
                    return [];
                const count = effects.length;
                const attack = effects.flatMap(({ statMods }) => statMods)
                    .filter((modifier) => modifier.stat === 'attack' && modifier.op === 'add')
                    .reduce((total, modifier) => total + modifier.value, 0);
                return attack > 0
                    ? [{
                            id: 'pull-into-clot-attack',
                            symbol: '◍',
                            label: count === 1 ? 'Стянуться в ком' : `Стянуться в ком ×${count}`,
                            description: `Получает +${attack} к атаке в этом раунде.`,
                            tone: 'positive',
                        }]
                    : [{
                            id: 'pull-into-clot-prohibit',
                            symbol: '◍',
                            label: count === 1 ? 'Стянуться в ком' : `Стянуться в ком ×${count}`,
                            description: 'Не атакует в этом раунде.',
                            tone: 'negative',
                        }];
            }],
    },
});
//# sourceMappingURL=pull_into_clot.js.map